module.exports = __webpack_public_path__ + "static/img/Empty-Company.fbaed3e4.png";